import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef/index.ts';
import { useAuth } from '../../authContext.js';
import useTokenStorage from '../useTokenStorage.js';
import { useImpersonateUser } from './useImpersonateUser.js';
import { useSelectCompany } from './useSelectCompany.js';
export const useLogout = () => {
    const { forgetAuthToken } = useTokenStorage();
    const { setIdentity, setLoggedUser, setToken } = useAuth();
    const selectCompany = useSelectCompany();
    const impersonateUser = useImpersonateUser();
    return useCallbackRef(() => {
        forgetAuthToken();
        setToken(null);
        setLoggedUser(undefined);
        setIdentity(undefined);
        selectCompany(null);
        impersonateUser(null);
    });
};
